import { useEffect, useRef } from "react";
import "./style.scss";

export default function LoadCard({
  proportional
}:{
  proportional?:boolean;
}){
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(()=>{
    const element = ref.current;
    if(element){
      if(proportional){
        let rect =  element.getBoundingClientRect()
        element.style.height = `${rect.width}px`;
      }
    }
  },[proportional])

  return (
    <div className="load-card" ref={ref}></div>
  );
}